/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';

/**
 *
 * @export
 * @interface ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate
 */
export interface ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate {
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate
   */
  protocol: ConversationalAgentProtocolEnum;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate
   */
  credentialValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate
   */
  name: string;
  /**
   *
   * @type {Date}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate
   */
  environment: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate
   */
  domain?: string;
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate interface.
 */
export function instanceOfConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate(
  value: object,
): value is ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('environment' in value) || value['environment'] === undefined) return false;
  if (!('tenant' in value) || value['tenant'] === undefined) return false;
  return true;
}

export function ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreateFromJSON(
  json: any,
): ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate {
  return ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreateFromJSONTyped(
    json,
    false,
  );
}

export function ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate {
  if (json == null) {
    return json;
  }
  return {
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
    credentialValue: json['credential_value'] == null ? undefined : json['credential_value'],
    name: json['name'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    environment: json['environment'],
    tenant: json['tenant'],
    region: json['region'] == null ? undefined : json['region'],
    domain: json['domain'] == null ? undefined : json['domain'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreateToJSON(
  value?: ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerCelinaCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
    credential_value: value['credentialValue'],
    name: value['name'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    environment: value['environment'],
    tenant: value['tenant'],
    region: value['region'],
    domain: value['domain'],
    credential_id: value['credentialId'],
  };
}
